import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxAssistanceFormServiceAdapter, NgxAssistanceFormUser } from '@mare-common/ngx-assistance-form';
import { ApiWpService } from '@mare-common/ngx-mare-auth';
import { CompanyServiceAbstract, UserServiceAbstract } from '@mare-common/ngx-mare-user';
import { catchError } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AssistanceFormAdapterImplementationService implements NgxAssistanceFormServiceAdapter {

  user!: {
    userId: string;
    name: string; 
    surname: string; 
    email: string; 
    phone: string;
    vatNumber: string;
    extras: any;
   };

  company!: any;


  constructor(
    private userService: UserServiceAbstract,
    private companyService: CompanyServiceAbstract,
    private apiWpService: ApiWpService
  ) {
    this.userService.getUser().then((user: any) => {
      this.user = user;
      this.companyService.getCompany().then((company: any) => {
        this.company = company;
      });
    });
  }
  populateOtherFields(assistanceForm: FormGroup<any>): unknown {
    return;
  }

  isDynamicForm(): boolean {
    return false;
  }
  getDynamicFormConfig() {
    return null;
  }


  public submitForm(body: any): Promise<any> {
    return new Promise((resolve, reject) => {

      const wpbody = {
        _wpcf7: environment.wpAssistanceFormId,
        "assistance-name": body.name,
        "assistance-email": body.email,
        "assistance-vatNumber": body.vatNumber,
        "assistance-phone": body.phone,
        "assistance-type": body.type,
        "assistance-message": body.message
      }
      this.apiWpService.postRequest('msc/v1/submitForm', wpbody).then((sub: any) => {
        sub
        .pipe(
          catchError((err: any) => {
            reject(err);
            console.log(err);
            return err;
          })
        )
        .subscribe((data: any) => {
          console.log(data);
          resolve(data);
        });
      });
    });
  }
  public isRecapthaRequired(): boolean {
    return true;
  }

  public getOptions(): { label: string; value: string; }[] {
    return [
      { value: 'contact_info', label: 'Richiesta informazioni' },
      { value: 'register_issue', label: 'Problema con la registrazione' },
      { value: 'tech_issue', label: 'Problema tecnico' },
      { value: 'selfcaring', label: 'Problema con un workflow' },
      { value: 'commerciale', label: 'Problema commerciale' },
    ];
  }

  public getUser(): Promise<NgxAssistanceFormUser | null>  {
    // this.user = {
    //   name: 'Claudio',
    //   surname: 'Autuori',
    //   email: 'claudio.autuori@maredigital.it',
    //   altraroba: null
    // };
    return new Promise((resolve, reject) => {
      if (this.user && this.company) {
        const ret: NgxAssistanceFormUser = {
          userId: this.user.userId,
          name: this.user.name,
          surname: this.user.surname,
          email: this.user.email,
          phone: this.user.phone,
          vatNumber: this.company.piva,
          captcha: null
        };
        resolve(ret);
      } else {
        
        this.userService.getUser().then((user: any) => {
          this.user = user;
          const ret: NgxAssistanceFormUser = {
            userId: this.user.userId,
            name: this.user.name,
            surname: this.user.surname,
            email: this.user.email,
            phone: this.user.phone,
            captcha: null
          };
          this.companyService.getCompany().then((company: any) => {
            ret.vatNumber = company.piva;
            resolve(ret);
          }).catch((err: any) => {
            reject(err);
          });
        }
        ).catch((err: any) => {
          reject(err);
        });
      }
    });
  }

  public setUser(user: NgxAssistanceFormUser): void {
    this.user = user as any;
  }
}
